import { ApiConfig } from "../../Config/ApiConfig";
import { createFormDataAction, createGetDataAction, createPostDataAction } from "./CommonAction";
import { CONTACTLIST , CONTACTDETAILS , CONTACTUPDATESTATUS } from "../../Constants/Contact_us";



export const ContactlistGetAction = (payload:any) => createPostDataAction(CONTACTLIST, ApiConfig?.ContactList,payload,false );
export const ContactDetailsGetAction = (payload:any) => createPostDataAction(CONTACTDETAILS, ApiConfig?.ContactDetails,payload,false );
export const ContactStatusGetAction = (payload:any) => createPostDataAction(CONTACTUPDATESTATUS, ApiConfig?.ContactStatus,payload,true );
